import { createStore, compose, combineReducers, applyMiddleware } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import createSagaMiddleware from 'redux-saga'
import { default as additionalMiddlewares } from '../middlewares'
import appReducers from '../reducers'
import runSagas from './saga'
import { createBrowserHistory } from 'history'

function isDevelopmentMode() {
  return (
    process.env.NODE_ENV === 'development' ||
    process.env.RELEASE_STAGE === 'development'
  )
}

export const history = createBrowserHistory()

function configureStore() {
  const sagaMiddleware = createSagaMiddleware()

  const rootReducer = combineReducers({ ...appReducers })

  const store = createStore(
    connectRouter(history)(rootReducer),
    {},
    compose(
      applyMiddleware(
        ...additionalMiddlewares,
        routerMiddleware(history),
        sagaMiddleware
      ),
      isDevelopmentMode() && window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f
    )
  )

  runSagas(sagaMiddleware)

  return store
}

export default configureStore()
